module.exports = __webpack_public_path__ + "static/img/jcICON3.9021114.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/data/jcICON3.png
// module id = uEqK
// module chunks = 49